<template>
	<div id="accountants">
		<!-- en-tête nom et logo entreprise  -->
		<div class="vx-row mt-3 mb-6 flex justify-between">
			<div class="vx-col w-full sm:w-1/2 flex justify-center sm:justify-between">
				<h2 class="title-sinao self-center" style="line-height: 35px">{{ $t("Mes collaborateurs") }}</h2>
			</div>

			<div class="w-fit vx-col flex justify-center sm:justify-end">
				<s-button
					icon="icon-plus"
					type="border"
					class="sm:m-base float-none sm:float-right"
					:disabled="loading"
					@click="$router.push({ name: 'Invite-accountant' })"
				>
					{{ $t("Ajouter un collaborateur") }}
				</s-button>
			</div>
		</div>

		<!-- current space explanation -->
		<div class="mb-4" style="color: #333">
			{{ $t("tooltip collaborateurs") }}
		</div>

		<!-- Team members -->
		<vx-card v-if="accountingFirm" class="mt-4 text-center shadow-none border">
			<h4 class="mb-3">{{ $t("Gestion des collaborateurs") }}</h4>

			<template v-for="accountant in filtered_accountants">
				<accountant-item :key="'accountant_' + accountant.id" :accountant="accountant" :apps="sorted_cases" />
			</template>

			<!-- add accountant manager himself => apps with no policies will be affected to him otherwise they are not listed anymore -->
			<accountant-me :apps="sorted_cases" />
		</vx-card>

		<!-- Invitations -->
		<template v-if="invitations_count > 0">
			<h4 class="mb-5 mt-10">{{ $t("Invitations en attente") }}</h4>

			<!-- On peut rajouter les attributs pagination & search si trop d'utilisateurs max-items="x" -->
			<vs-table
				ref="tableInviteAccountants"
				class="text-left relative"
				stripe
				:data="filtered_invitations"
				hover-flat
			>
				<template slot="thead">
					<vs-th />
					<vs-th>{{ $t("Nom") }}</vs-th>
					<vs-th>{{ $t("Email") }}</vs-th>
					<vs-th>{{ $t("Action") }}</vs-th>
				</template>

				<template slot-scope="{ data }">
					<vs-tr v-for="invite in data" :key="invite.id">
						<!-- Colonne 1 : photo avec gestion si admin -->
						<vs-td class="photoCol">
							<img
								:src="`https://sinao.app/services/avatar/${invite.firstname}${invite.lastname}/${invite.firstname[0]}${invite.lastname[0]}`"
								class="rounded-full"
								height="50px"
								width="50px"
								alt
							/>

							<!-- 
								TODO: tu peux peut etre améliorer en utilisant (invite.image = "/services/avatar/JohnDoe/JD"): 
								<img :src="getImageUrl(invite)" class="rounded-full" height="50px" width="50px" alt />
							-->
						</vs-td>

						<!-- Colonne 2 : prénom + nom -->
						<vs-td>{{ invite.firstname }} {{ invite.lastname }}</vs-td>

						<!-- Colonne 3 : email -->
						<vs-td>{{ invite.email }}</vs-td>

						<!-- Colonne 4 : action -->
						<vs-td>
							<div class="flex">
								<vs-button
									class="ml-3"
									radius
									size="large"
									color="danger"
									type="border"
									icon-pack="feather"
									icon="icon-delete"
									@click="confirmDelInvite(invite)"
								/>
							</div>
						</vs-td>
					</vs-tr>
				</template>
			</vs-table>
		</template>
		<!-- invitation deleter component -->
		<invitation-deleter
			:selected-invite="selectedInvite"
			:app-id="selectedInvite ? parseInt(selectedInvite.appId) : 0"
			@done="confirmDelDone"
		/>
	</div>
</template>

<script>
	//import { Fragment } from "vue-fragment";
	import { mapGetters, mapState } from "vuex";
	import AccountantItem from "@/components/AccountantItem.vue";
	import InvitationDeleter from "@/components/InvitationDeleter.vue";
	import AccountantMe from "@/components/AccountantMe.vue";
	export default {
		name: "Accountants",
		components: { AccountantItem, InvitationDeleter, AccountantMe },
		data() {
			return {
				types: ["default", "point", "radius", "corners", "border", "sound", "material"],
				loading: false,
				selectedInvite: null
			};
		},
		computed: {
			...mapGetters(["getImageUrl", "sorted_cases"]),
			...mapState(["user", "accountingFirm"]),
			filtered_invitations() {
				if (!this.accountingFirm.invitations) return [];

				return this.accountingFirm.invitations.reduce((acc, invite) => {
					if (acc.find(item => item.email === invite.email) === undefined) acc.push(invite);
					return acc;
				}, []);
			},
			filtered_accountants() {
				return this.accountingFirm?.users?.filter(u => u.id !== this.user.id) || [];
			},
			invitations_count() {
				return this.accountingFirm?.invitations?.length || 0;
			}
		},
		methods: {
			confirmDelInvite(invite) {
				this.selectedInvite = invite; // component InvitationDeleter handle
			},
			async confirmDelDone(confirm_value) {
				if (!confirm_value) {
					this.selectedInvite = null;
				} else {
					// reload me
					await this.$store.dispatch("getAccountingFirm");
				}
			}
		}
	};
</script>

<style scoped>
	.selector_button {
		padding: 0.4rem 0.6rem !important;
	}
</style>
